// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__rUjA1","col":"styles_col__2MqP3"};